import type { FetchInputType } from "./types/fetch-params";

// The BigQuery web-event beacon (`window.InnerBalanceClientApi.sendWebEvent`,
// wired up in `ClientApiScript`). This is a SEPARATE telemetry channel from
// Datadog (`useLogEvent`): these events land in BigQuery `ods.prod_web_*`.
// Centralised here so the decision of WHAT reaches the BigQuery error stream
// (`ods.prod_web_errors`) lives in one place — see `useFetchBase`, which only
// calls `sendErrorBeacon` for genuine, unrecovered network failures.

// The coordinates of a click or tap anywhere on the page (`NavigationEvents`).
export const CLICK_EVENT_NAME = "click";
// Every error report sent to BigQuery uses this name, not just `sendErrorBeacon`:
// the event service relies on it to keep a failed report from being reported.
export const ERROR_BEACON_EVENT_NAME = "error";

// Fires the error beacon (`event_name: "error"`) — the one that feeds BigQuery
// `ods.prod_web_errors`. Call ONLY for real errors; benign client-side
// cancellations must NOT reach this channel (see `logFetchCancellation`).
export function sendErrorBeacon(input: FetchInputType, message: string): void {
    // Only string inputs produce meaningful telemetry. A URL/Request object
    // would serialize unpredictably (a `Request` → `{}`), so skip it.
    if (typeof input !== "string") {
        return;
    }

    window.InnerBalanceClientApi?.sendWebEvent({
        event_name: ERROR_BEACON_EVENT_NAME,
        event_type: "user_non_interaction",
        widget: "api",
        meta_data: {
            url: input,
            error_text: message,
            error_msg_response: message,
        },
    });
}
